// import React, { useState, useRef } from 'react';
// import styled from 'styled-components';
// import { updateProfile, changePassword } from '../../services/api';

// const ModalOverlay = styled.div`
//   position: fixed;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   background: rgba(0,0,0,0.5);
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   z-index: 2000;
// `;

// const ModalContent = styled.div`
//   background: white;
//   border-radius: 20px;
//   width: 90%;
//   max-width: 550px;
//   max-height: 85vh;
//   overflow-y: auto;
//   padding: 30px;
//   position: relative;
  
//   &::-webkit-scrollbar {
//     width: 8px;
//   }
  
//   &::-webkit-scrollbar-track {
//     background: #f1f1f1;
//     border-radius: 10px;
//   }
  
//   &::-webkit-scrollbar-thumb {
//     background: #c4a484;
//     border-radius: 10px;
//   }
// `;

// const ModalHeader = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   margin-bottom: 25px;
//   padding-bottom: 15px;
//   border-bottom: 1px solid #eee;
  
//   h2 {
//     margin: 0;
//     color: #1a2a3a;
//     font-size: 24px;
//     font-weight: 300;
//   }
  
//   button {
//     background: none;
//     border: none;
//     font-size: 24px;
//     cursor: pointer;
//     color: #666;
//     transition: color 0.3s;
    
//     &:hover {
//       color: #c4a484;
//     }
//   }
// `;

// const ProfilePictureSection = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   margin-bottom: 30px;
//   padding-bottom: 20px;
//   border-bottom: 1px solid #eee;
// `;

// const ProfileImage = styled.div`
//   position: relative;
//   width: 120px;
//   height: 120px;
//   margin-bottom: 15px;
// `;

// const AvatarImage = styled.img`
//   width: 100%;
//   height: 100%;
//   border-radius: 50%;
//   object-fit: cover;
//   border: 3px solid #c4a484;
//   box-shadow: 0 5px 15px rgba(0,0,0,0.1);
//   background: #f0f0f0;
// `;

// const UploadButton = styled.button`
//   position: absolute;
//   bottom: 5px;
//   right: 5px;
//   background: #c4a484;
//   border: none;
//   border-radius: 50%;
//   width: 36px;
//   height: 36px;
//   cursor: pointer;
//   font-size: 18px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   transition: all 0.3s;
//   box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  
//   &:hover {
//     background: #b89474;
//     transform: scale(1.05);
//   }
// `;

// const HiddenFileInput = styled.input`
//   display: none;
// `;

// const ButtonGroup = styled.div`
//   display: flex;
//   gap: 10px;
//   margin-top: 10px;
// `;

// const ColorButton = styled.button`
//   background: transparent;
//   border: 1px solid #c4a484;
//   color: #c4a484;
//   padding: 8px 16px;
//   border-radius: 20px;
//   cursor: pointer;
//   font-size: 12px;
//   transition: all 0.3s;
  
//   &:hover {
//     background: #c4a484;
//     color: white;
//   }
// `;

// const ColorPalette = styled.div`
//   display: flex;
//   gap: 12px;
//   flex-wrap: wrap;
//   justify-content: center;
//   margin-top: 15px;
// `;

// const ColorOption = styled.button`
//   width: 40px;
//   height: 40px;
//   border-radius: 50%;
//   background: ${props => props.color};
//   border: 2px solid ${props => props.selected ? '#c4a484' : 'transparent'};
//   cursor: pointer;
//   transition: all 0.3s;
//   box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  
//   &:hover {
//     transform: scale(1.1);
//     border-color: #c4a484;
//   }
// `;

// const FormGroup = styled.div`
//   margin-bottom: 20px;
// `;

// const Label = styled.label`
//   display: block;
//   margin-bottom: 8px;
//   color: #333;
//   font-weight: 500;
//   font-size: 14px;
// `;

// const Input = styled.input`
//   width: 100%;
//   padding: 12px;
//   border: 1px solid #ddd;
//   border-radius: 8px;
//   font-size: 14px;
//   transition: all 0.3s;
  
//   &:focus {
//     outline: none;
//     border-color: #c4a484;
//     box-shadow: 0 0 0 3px rgba(196, 164, 132, 0.1);
//   }
  
//   &:disabled {
//     background: #f8f9fa;
//     color: #999;
//   }
// `;

// const TextArea = styled.textarea`
//   width: 100%;
//   padding: 12px;
//   border: 1px solid #ddd;
//   border-radius: 8px;
//   font-size: 14px;
//   min-height: 80px;
//   resize: vertical;
  
//   &:focus {
//     outline: none;
//     border-color: #c4a484;
//   }
// `;

// const Button = styled.button`
//   width: 100%;
//   padding: 12px;
//   background: #c4a484;
//   color: white;
//   border: none;
//   border-radius: 8px;
//   font-size: 16px;
//   font-weight: 600;
//   cursor: pointer;
//   transition: all 0.3s;
  
//   &:hover {
//     background: #b89474;
//     transform: translateY(-2px);
//   }
  
//   &:disabled {
//     background: #ccc;
//     cursor: not-allowed;
//     transform: none;
//   }
// `;

// const Message = styled.p`
//   color: ${props => props.error ? '#e74c3c' : '#27ae60'};
//   font-size: 12px;
//   margin-top: 8px;
//   text-align: center;
// `;

// const Section = styled.div`
//   border-bottom: 1px solid #eee;
//   padding-bottom: 25px;
//   margin-bottom: 25px;
  
//   &:last-child {
//     border-bottom: none;
//     margin-bottom: 0;
//     padding-bottom: 0;
//   }
// `;

// const SectionTitle = styled.h3`
//   margin-bottom: 20px;
//   color: #1a2a3a;
//   font-size: 18px;
//   font-weight: 500;
// `;

// const colorOptions = [
//   { name: 'Gold', value: 'c4a484', bg: '#c4a484' },
//   { name: 'Blue', value: '3498db', bg: '#3498db' },
//   { name: 'Green', value: '2ecc71', bg: '#2ecc71' },
//   { name: 'Red', value: 'e74c3c', bg: '#e74c3c' },
//   { name: 'Purple', value: '9b59b6', bg: '#9b59b6' },
//   { name: 'Orange', value: 'e67e22', bg: '#e67e22' },
//   { name: 'Pink', value: 'e84393', bg: '#e84393' },
//   { name: 'Teal', value: '1abc9c', bg: '#1abc9c' },
// ];

// const AccountSettings = ({ user, onClose, onUpdate }) => {
//   const [formData, setFormData] = useState({
//     name: user.name || '',
//     bio: user.bio || '',
//     phone: user.phone || '',
//     address: user.address || ''
//   });
//   const [profileColor, setProfileColor] = useState('c4a484');
//   const [uploadedImage, setUploadedImage] = useState(null);
//   const [passwordData, setPasswordData] = useState({
//     currentPassword: '',
//     newPassword: '',
//     confirmPassword: ''
//   });
//   const [message, setMessage] = useState('');
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);
//   const fileInputRef = useRef(null);

//   const getAvatarUrl = (name, color, uploadedImageUrl = null) => {
//     if (uploadedImageUrl) {
//       return uploadedImageUrl;
//     }
//     const initial = name?.charAt(0)?.toUpperCase() || 'U';
//     return `https://ui-avatars.com/api/?background=${color}&color=fff&name=${initial}&size=120&font-size=50&bold=true`;
//   };

//   const handleImageUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       // Check file size (max 2MB)
//       if (file.size > 2 * 1024 * 1024) {
//         setError('Image size should be less than 2MB');
//         return;
//       }
      
//       // Check file type
//       if (!file.type.startsWith('image/')) {
//         setError('Please upload an image file');
//         return;
//       }
      
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setUploadedImage(reader.result);
//         setError('');
//         setMessage('Image selected! Click "Save Changes" to update your profile.');
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleProfileUpdate = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError('');
//     setMessage('');
    
//     try {
//       await updateProfile(formData);
      
//       // Use uploaded image if available, otherwise generate avatar
//       let profilePic = user.profile_pic;
//       if (uploadedImage) {
//         profilePic = uploadedImage;
//       } else if (!user.profile_pic) {
//         profilePic = getAvatarUrl(formData.name, profileColor);
//       }
      
//       const updatedUser = { ...user, ...formData, profile_pic: profilePic };
//       setMessage('Profile updated successfully!');
//       onUpdate(updatedUser);
//       setTimeout(() => setMessage(''), 3000);
//     } catch (err) {
//       setError('Failed to update profile');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePasswordChange = async (e) => {
//     e.preventDefault();
    
//     if (passwordData.newPassword !== passwordData.confirmPassword) {
//       setError('New passwords do not match');
//       return;
//     }
    
//     if (passwordData.newPassword.length < 6) {
//       setError('Password must be at least 6 characters');
//       return;
//     }
    
//     setLoading(true);
//     setError('');
//     setMessage('');
    
//     try {
//       await changePassword({
//         currentPassword: passwordData.currentPassword,
//         newPassword: passwordData.newPassword
//       });
//       setMessage('Password changed successfully!');
//       setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
//       setTimeout(() => setMessage(''), 3000);
//     } catch (err) {
//       setError(err.response?.data?.error || 'Failed to change password');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleResetToColor = () => {
//     setUploadedImage(null);
//     setMessage('Avatar will be reset to color-based avatar. Click "Save Changes" to update.');
//   };

//   const currentAvatar = uploadedImage || user?.profile_pic || getAvatarUrl(formData.name, profileColor);

//   return (
//     <ModalOverlay onClick={onClose}>
//       <ModalContent onClick={(e) => e.stopPropagation()}>
//         <ModalHeader>
//           <h2>Account Settings</h2>
//           <button onClick={onClose}>✕</button>
//         </ModalHeader>
        
//         <Section>
//           <SectionTitle>Profile Picture</SectionTitle>
//           <ProfilePictureSection>
//             <ProfileImage>
//               <AvatarImage src={currentAvatar} alt={formData.name} />
//               <UploadButton onClick={() => fileInputRef.current?.click()} title="Upload image">
//                 📷
//               </UploadButton>
//             </ProfileImage>
//             <HiddenFileInput
//               ref={fileInputRef}
//               type="file"
//               accept="image/*"
//               onChange={handleImageUpload}
//             />
//             <ButtonGroup>
//               <ColorButton onClick={() => fileInputRef.current?.click()}>
//                 📷 Upload Photo
//               </ColorButton>
//               <ColorButton onClick={handleResetToColor}>
//                 🎨 Use Color Avatar
//               </ColorButton>
//             </ButtonGroup>
//             <ColorPalette>
//               {colorOptions.map(color => (
//                 <ColorOption
//                   key={color.name}
//                   color={color.bg}
//                   selected={profileColor === color.value}
//                   onClick={() => {
//                     setProfileColor(color.value);
//                     if (!uploadedImage && !user?.profile_pic) {
//                       setMessage('Color changed! Click "Save Changes" to update.');
//                     }
//                   }}
//                   title={color.name}
//                 />
//               ))}
//             </ColorPalette>
//             <p style={{ fontSize: '12px', color: '#666', marginTop: '10px' }}>
//               Click 📷 to upload a photo or choose a color for initial avatar
//             </p>
//           </ProfilePictureSection>
//         </Section>
        
//         <Section>
//           <SectionTitle>Profile Information</SectionTitle>
//           <form onSubmit={handleProfileUpdate}>
//             <FormGroup>
//               <Label>Full Name</Label>
//               <Input
//                 type="text"
//                 value={formData.name}
//                 onChange={(e) => setFormData({...formData, name: e.target.value})}
//                 required
//               />
//             </FormGroup>
            
//             <FormGroup>
//               <Label>Email</Label>
//               <Input type="email" value={user.email} disabled />
//             </FormGroup>
            
//             <FormGroup>
//               <Label>Bio</Label>
//               <TextArea
//                 value={formData.bio}
//                 onChange={(e) => setFormData({...formData, bio: e.target.value})}
//                 placeholder="Tell us about yourself..."
//               />
//             </FormGroup>
            
//             <FormGroup>
//               <Label>Phone</Label>
//               <Input
//                 type="tel"
//                 value={formData.phone}
//                 onChange={(e) => setFormData({...formData, phone: e.target.value})}
//                 placeholder="Your phone number"
//               />
//             </FormGroup>
            
//             <FormGroup>
//               <Label>Address</Label>
//               <Input
//                 type="text"
//                 value={formData.address}
//                 onChange={(e) => setFormData({...formData, address: e.target.value})}
//                 placeholder="Your address"
//               />
//             </FormGroup>
            
//             <Button type="submit" disabled={loading}>
//               {loading ? 'Saving...' : 'Save Changes'}
//             </Button>
//           </form>
//         </Section>
        
//         <Section>
//           <SectionTitle>Change Password</SectionTitle>
//           <form onSubmit={handlePasswordChange}>
//             <FormGroup>
//               <Label>Current Password</Label>
//               <Input
//                 type="password"
//                 value={passwordData.currentPassword}
//                 onChange={(e) => setPasswordData({...passwordData, currentPassword: e.target.value})}
//                 required
//               />
//             </FormGroup>
            
//             <FormGroup>
//               <Label>New Password</Label>
//               <Input
//                 type="password"
//                 value={passwordData.newPassword}
//                 onChange={(e) => setPasswordData({...passwordData, newPassword: e.target.value})}
//                 required
//                 placeholder="Minimum 6 characters"
//               />
//             </FormGroup>
            
//             <FormGroup>
//               <Label>Confirm New Password</Label>
//               <Input
//                 type="password"
//                 value={passwordData.confirmPassword}
//                 onChange={(e) => setPasswordData({...passwordData, confirmPassword: e.target.value})}
//                 required
//               />
//             </FormGroup>
            
//             <Button type="submit" disabled={loading}>
//               {loading ? 'Changing...' : 'Change Password'}
//             </Button>
//           </form>
//         </Section>
        
//         {message && <Message>{message}</Message>}
//         {error && <Message error>{error}</Message>}
//       </ModalContent>
//     </ModalOverlay>
//   );
// };

// export default AccountSettings;


import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { updateProfile, changePassword, updateProfilePic } from '../../services/api';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 20px;
  width: 90%;
  max-width: 550px;
  max-height: 85vh;
  overflow-y: auto;
  padding: 30px;
  position: relative;
  
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c4a484;
    border-radius: 10px;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
  
  h2 {
    margin: 0;
    color: #1a2a3a;
    font-size: 24px;
    font-weight: 300;
  }
  
  button {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #666;
    transition: color 0.3s;
    
    &:hover {
      color: #c4a484;
    }
  }
`;

const ProfilePictureSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
`;

const ProfileImage = styled.div`
  position: relative;
  width: 120px;
  height: 120px;
  margin-bottom: 15px;
`;

const AvatarImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #c4a484;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  background: #f0f0f0;
`;

const UploadButton = styled.button`
  position: absolute;
  bottom: 5px;
  right: 5px;
  background: #c4a484;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  cursor: pointer;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  
  &:hover {
    background: #b89474;
    transform: scale(1.05);
  }
`;

const HiddenFileInput = styled.input`
  display: none;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
`;

const ColorButton = styled.button`
  background: transparent;
  border: 1px solid #c4a484;
  color: #c4a484;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.3s;
  
  &:hover {
    background: #c4a484;
    color: white;
  }
`;

const ColorPalette = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 15px;
`;

const ColorOption = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${props => props.color};
  border: 2px solid ${props => props.selected ? '#c4a484' : 'transparent'};
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  
  &:hover {
    transform: scale(1.1);
    border-color: #c4a484;
  }
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-weight: 500;
  font-size: 14px;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s;
  
  &:focus {
    outline: none;
    border-color: #c4a484;
    box-shadow: 0 0 0 3px rgba(196, 164, 132, 0.1);
  }
  
  &:disabled {
    background: #f8f9fa;
    color: #999;
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  min-height: 80px;
  resize: vertical;
  
  &:focus {
    outline: none;
    border-color: #c4a484;
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 12px;
  background: #c4a484;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    background: #b89474;
    transform: translateY(-2px);
  }
  
  &:disabled {
    background: #ccc;
    cursor: not-allowed;
    transform: none;
  }
`;

const Message = styled.p`
  color: ${props => props.error ? '#e74c3c' : '#27ae60'};
  font-size: 12px;
  margin-top: 8px;
  text-align: center;
`;

const Section = styled.div`
  border-bottom: 1px solid #eee;
  padding-bottom: 25px;
  margin-bottom: 25px;
  
  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
`;

const SectionTitle = styled.h3`
  margin-bottom: 20px;
  color: #1a2a3a;
  font-size: 18px;
  font-weight: 500;
`;

const colorOptions = [
  { name: 'Gold', value: 'c4a484', bg: '#c4a484' },
  { name: 'Blue', value: '3498db', bg: '#3498db' },
  { name: 'Green', value: '2ecc71', bg: '#2ecc71' },
  { name: 'Red', value: 'e74c3c', bg: '#e74c3c' },
  { name: 'Purple', value: '9b59b6', bg: '#9b59b6' },
  { name: 'Orange', value: 'e67e22', bg: '#e67e22' },
  { name: 'Pink', value: 'e84393', bg: '#e84393' },
  { name: 'Teal', value: '1abc9c', bg: '#1abc9c' },
];

const AccountSettings = ({ user, onClose, onUpdate }) => {
  const [formData, setFormData] = useState({
    name: user.name || '',
    bio: user.bio || '',
    phone: user.phone || '',
    address: user.address || ''
  });
  const [profileColor, setProfileColor] = useState('c4a484');
  const [uploadedImage, setUploadedImage] = useState(null);
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  const getAvatarUrl = (name, color, uploadedImageUrl = null) => {
    if (uploadedImageUrl) {
      return uploadedImageUrl;
    }
    const initial = name?.charAt(0)?.toUpperCase() || 'U';
    return `https://ui-avatars.com/api/?background=${color}&color=fff&name=${initial}&size=120&font-size=50&bold=true`;
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        setError('Image size should be less than 2MB');
        return;
      }
      
      if (!file.type.startsWith('image/')) {
        setError('Please upload an image file');
        return;
      }
      
      const reader = new FileReader();
      reader.onloadend = () => {
        setUploadedImage(reader.result);
        setError('');
        setMessage('Image selected! Click "Save Changes" to update your profile.');
      };
      reader.readAsDataURL(file);
    }
  };

  const handleProfileUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');
    
    try {
      // Update profile info
      await updateProfile(formData);
      
      // Update profile picture if uploaded
      let profilePic = user.profile_pic;
      if (uploadedImage) {
        // Save the uploaded image to database
        const picResult = await updateProfilePic(uploadedImage);
        if (picResult.success) {
          profilePic = picResult.profile_pic || uploadedImage;
        }
      } else if (!user.profile_pic) {
        // Generate color avatar if no profile picture
        profilePic = getAvatarUrl(formData.name, profileColor);
        await updateProfilePic(profilePic);
      }
      
      const updatedUser = { ...user, ...formData, profile_pic: profilePic };
      setMessage('Profile updated successfully!');
      onUpdate(updatedUser);
      setUploadedImage(null);
      
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      setError('Failed to update profile');
      console.error('Update error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setError('New passwords do not match');
      return;
    }
    
    if (passwordData.newPassword.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    
    setLoading(true);
    setError('');
    setMessage('');
    
    try {
      await changePassword({
        currentPassword: passwordData.currentPassword,
        newPassword: passwordData.newPassword
      });
      setMessage('Password changed successfully!');
      setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  const handleResetToColor = () => {
    setUploadedImage(null);
    setMessage('Avatar will be reset to color-based avatar. Click "Save Changes" to update.');
  };

  const currentAvatar = uploadedImage || user?.profile_pic || getAvatarUrl(formData.name, profileColor);

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <h2>Account Settings</h2>
          <button onClick={onClose}>✕</button>
        </ModalHeader>
        
        <Section>
          <SectionTitle>Profile Picture</SectionTitle>
          <ProfilePictureSection>
            <ProfileImage>
              <AvatarImage src={currentAvatar} alt={formData.name} />
              <UploadButton onClick={() => fileInputRef.current?.click()} title="Upload image">
                📷
              </UploadButton>
            </ProfileImage>
            <HiddenFileInput
              ref={fileInputRef}
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
            />
            <ButtonGroup>
              <ColorButton onClick={() => fileInputRef.current?.click()}>
                📷 Upload Photo
              </ColorButton>
              <ColorButton onClick={handleResetToColor}>
                🎨 Use Color Avatar
              </ColorButton>
            </ButtonGroup>
            <ColorPalette>
              {colorOptions.map(color => (
                <ColorOption
                  key={color.name}
                  color={color.bg}
                  selected={profileColor === color.value}
                  onClick={() => {
                    setProfileColor(color.value);
                    if (!uploadedImage && !user?.profile_pic) {
                      setMessage('Color changed! Click "Save Changes" to update.');
                    }
                  }}
                  title={color.name}
                />
              ))}
            </ColorPalette>
            <p style={{ fontSize: '12px', color: '#666', marginTop: '10px' }}>
              Click 📷 to upload a photo or choose a color for initial avatar
            </p>
          </ProfilePictureSection>
        </Section>
        
        <Section>
          <SectionTitle>Profile Information</SectionTitle>
          <form onSubmit={handleProfileUpdate}>
            <FormGroup>
              <Label>Full Name</Label>
              <Input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                required
              />
            </FormGroup>
            
            <FormGroup>
              <Label>Email</Label>
              <Input type="email" value={user.email} disabled />
            </FormGroup>
            
            <FormGroup>
              <Label>Bio</Label>
              <TextArea
                value={formData.bio}
                onChange={(e) => setFormData({...formData, bio: e.target.value})}
                placeholder="Tell us about yourself..."
              />
            </FormGroup>
            
            <FormGroup>
              <Label>Phone</Label>
              <Input
                type="tel"
                value={formData.phone}
                onChange={(e) => setFormData({...formData, phone: e.target.value})}
                placeholder="Your phone number"
              />
            </FormGroup>
            
            <FormGroup>
              <Label>Address</Label>
              <Input
                type="text"
                value={formData.address}
                onChange={(e) => setFormData({...formData, address: e.target.value})}
                placeholder="Your address"
              />
            </FormGroup>
            
            <Button type="submit" disabled={loading}>
              {loading ? 'Saving...' : 'Save Changes'}
            </Button>
          </form>
        </Section>
        
        <Section>
          <SectionTitle>Change Password</SectionTitle>
          <form onSubmit={handlePasswordChange}>
            <FormGroup>
              <Label>Current Password</Label>
              <Input
                type="password"
                value={passwordData.currentPassword}
                onChange={(e) => setPasswordData({...passwordData, currentPassword: e.target.value})}
                required
              />
            </FormGroup>
            
            <FormGroup>
              <Label>New Password</Label>
              <Input
                type="password"
                value={passwordData.newPassword}
                onChange={(e) => setPasswordData({...passwordData, newPassword: e.target.value})}
                required
                placeholder="Minimum 6 characters"
              />
            </FormGroup>
            
            <FormGroup>
              <Label>Confirm New Password</Label>
              <Input
                type="password"
                value={passwordData.confirmPassword}
                onChange={(e) => setPasswordData({...passwordData, confirmPassword: e.target.value})}
                required
              />
            </FormGroup>
            
            <Button type="submit" disabled={loading}>
              {loading ? 'Changing...' : 'Change Password'}
            </Button>
          </form>
        </Section>
        
        {message && <Message>{message}</Message>}
        {error && <Message error>{error}</Message>}
      </ModalContent>
    </ModalOverlay>
  );
};

export default AccountSettings;